export enum GoogleConsentValues {
	Denied = "denied",
	Granted = "granted",
}

// export type GoogleConsentValues = "denied" | "granted";

export type GoogleConsentApiType = "gtag" | "gtmApi" | "both" | "none";

/**
 *  ad_storage	Enables storage, such as cookies, related to advertising.
 * 	ad_user_data	Sets consent for sending user data to Google for online advertising purposes.
 * 	ad_personalization	Sets consent for personalized advertising.
 * 	analytics_storage	Enables storage, such as cookies, related to analytics (for example, visit duration).
 * 	functionality_storage	Enables storage that supports the functionality of the website or app such as language settings.
 * 	personalization_storage	Enables storage related to personalization such as video recommendations.
 * 	security_storage	Enables storage related to security such as authentication functionality, fraud prevention, and other user protection
 */
export interface GoogleConsents {
	ad_storage?: GoogleConsentValues;
	ad_user_data?: GoogleConsentValues;
	ad_personalization?: GoogleConsentValues;
	analytics_storage?: GoogleConsentValues;
	functionality_storage?: GoogleConsentValues;
	personalization_storage?: GoogleConsentValues;
	security_storage?: GoogleConsentValues;
}
